module.exports = __webpack_public_path__ + "static/img/image13.20e52cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image13.png
// module id = Zoqn
// module chunks = 14